<template>
    <div>
        <Breadcrumbs main="Admin" submain="House" title="Register House" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div class="form theme-form">
                                <p style="font-size: larger; font-weight: 600;">Address (ঠিকানা)</p>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Shelter (আশ্রয়কেন্দ্র)</label> 
                                            <select class="form-control digits" v-model="house.home_address.address_shelter" style="height: 44px;" @change="getAddress">
                                                <option selected disabled>Select a shelter</option>
                                                <option v-for="(type, index) in shelter_list" :key="index" :value="type.id">{{ type.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Union (ইউনিয়ন)</label>
                                            <select disabled class="form-control digits" v-model="house.home_address.address_union" style="height: 44px;">
                                                <option selected disabled>Select a union</option>
                                                <option v-for="(type, index) in union" :key="index" :value="type.id">{{ type.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Upazila (উপজেলা)</label>
                                            <select disabled class="form-control digits" v-model="house.home_address.address_upozila" style="height: 44px;">
                                                <option selected disabled>Select a upazila</option>
                                                <option v-for="(type, index) in upozilas" :key="index" :value="type.id">{{ type.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>House Name (বাড়ীর নাম)</label>
                                            <input class="form-control" type="text" placeholder="Type House Name (বাড়ীর নাম)" v-model="house.home.house_name" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>House Type (বাড়ীর কাঠামো)</label>
                                            <select class="form-control digits" v-model="house.home.house_type" style="height: 44px;">
                                                <option selected disabled>Select a type</option>
                                                <option v-for="(type, index) in house_types" :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>House Geo Location (জিও লোকেশন)</label>
                                            <input class="form-control" type="text" placeholder="Type House Geo Location (জিও লোকেশন)" v-model="house.home.house_geo_location" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Distance (দূরত্ব)</label>
                                            <input class="form-control" type="text" placeholder="Type House Distance (দূরত্ব)" v-model="house.home.home_distance_from_shelter" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>House to Shelter Road Condition (রাস্তার অবস্থা)</label> 
                                            <select class="form-control digits" v-model="house.home.road_condition" style="height: 44px;">
                                                <option selected disabled>Select a condition</option>
                                                <option v-for="(type, index) in road_conditions" :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Image (বাড়ীর ছবি)</label>
                                            <div class="flex items-center">
                                                <img v-if="home_image_1" style="height: 80px; width: 80px; border-radius: 6px;" :src="home_image_1">
                                                <input :class="home_image_1 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadHomeImage1">
                                            </div>
                                            <div class="flex items-center my-3">
                                                <img v-if="home_image_2" style="height: 80px; width: 80px; border-radius: 6px;" :src="home_image_2">
                                                <input :class="home_image_2 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadHomeImage2">
                                            </div>
                                            <div class="flex items-center">
                                                <img v-if="home_image_3" style="height: 80px; width: 80px; border-radius: 6px;" :src="home_image_3">
                                                <input :class="home_image_3 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadHomeImage3">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p style="font-size: larger; font-weight: 600; margin-top: 12px;">Family Representative (প্রধান সদস্য)</p>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Name (নাম)</label>
                                            <input class="form-control" type="text" placeholder="Type Name (নাম)" v-model="house.user1.name" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Number (ফোন নাম্বার)</label>
                                            <input class="form-control" type="text" placeholder="Type Phone Number (ফোন নাম্বার)" v-model="house.user1.phone" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>NID (এনআইডি)</label>
                                            <input class="form-control" type="text" placeholder="Type NID (এনআইডি)" v-model="house.user1.nid" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Gender (লিঙ্গ)</label>
                                            <select class="form-control digits" v-model="house.user1.gender" style="height: 44px;">
                                                <option selected disabled>Select a gender</option>
                                                <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Age (বয়স)</label>
                                            <select class="form-control digits" v-model="house.user1.age" style="height: 44px;">
                                                <option selected disabled>Select a age</option>
                                                <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Health Condition (শারীরিক অবস্থা)</label>
                                            <select class="form-control digits" v-model="house.user1.health_condition" style="height: 44px;">
                                                <option selected disabled>Select a condition</option>
                                                <option v-for="(type, index) in healthCondition " :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Total Members (পরিবারের সদস্য সংখ্যা)</label>
                                            <select class="form-control digits" v-model="house.user1.total_member" style="height: 44px;" @change="getOtherUser">
                                                <option selected disabled>Select a number</option>
                                                <option v-for="(type, index) in totalMember " :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Image (প্রধান সদস্যের ছবি)</label>
                                            <div class="flex items-center">
                                                <img v-if="user1_image_1" style="height: 80px; width: 80px; border-radius: 6px;" :src="user1_image_1">
                                                <input :class="user1_image_1 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser1Image1">
                                            </div>
                                            <div class="flex items-center my-3">
                                                <img v-if="user1_image_2" style="height: 80px; width: 80px; border-radius: 6px;" :src="user1_image_2">
                                                <input :class="user1_image_2 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser1Image2">
                                            </div>
                                            <div class="flex items-center">
                                                <img v-if="user1_image_3" style="height: 80px; width: 80px; border-radius: 6px;" :src="user1_image_3">
                                                <input :class="user1_image_3 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser1Image3">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p style="font-size: larger; font-weight: 600; margin-top: 12px;">Sub Representative (উপ সদস্য)</p>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Name (নাম)</label>
                                            <input class="form-control" type="text" placeholder="Type Name (নাম)" v-model="house.user2.name" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Number (ফোন নাম্বার)</label>
                                            <input class="form-control" type="text" placeholder="Type Phone Number (ফোন নাম্বার)" v-model="house.user2.phone" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>NID (এনআইডি)</label>
                                            <input class="form-control" type="text" placeholder="Type NID (এনআইডি)" v-model="house.user2.nid" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Gender (লিঙ্গ)</label>
                                            <select class="form-control digits" v-model="house.user2.gender" style="height: 44px;">
                                                <option selected disabled>Select a gender</option>
                                                <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Age (বয়স)</label>
                                            <select class="form-control digits" v-model="house.user2.age" style="height: 44px;">
                                                <option selected disabled>Select a age</option>
                                                <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Health Condition (শারীরিক অবস্থা)</label>
                                            <select class="form-control digits" v-model="house.user2.health_condition" style="height: 44px;">
                                                <option selected disabled>Select a condition</option>
                                                <option v-for="(type, index) in healthCondition" :key="index" :value="type">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Image (উপ সদস্যের ছবি)</label>
                                            <div class="flex items-center">
                                                <img v-if="user2_image_1" style="height: 80px; width: 80px; border-radius: 6px;" :src="user2_image_1">
                                                <input :class="user2_image_1 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser2Image1">
                                            </div>
                                            <div class="flex items-center my-3">
                                                <img v-if="user2_image_2" style="height: 80px; width: 80px; border-radius: 6px;" :src="user2_image_2">
                                                <input :class="user2_image_2 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser2Image2">
                                            </div>
                                            <div class="flex items-center">
                                                <img v-if="user2_image_3" style="height: 80px; width: 80px; border-radius: 6px;" :src="user2_image_3">
                                                <input :class="user2_image_3 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadUser2Image3">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-for="(member, index) in this.house.other_members" :key="index">
                                    <p style="font-size: larger; font-weight: 600; margin-top: 12px;">Member- {{ index + 3 }} Details (মেম্বার- {{ index + 3 }} এর বিবরণ)</p>

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Gender (লিঙ্গ)</label>
                                                <select class="form-control digits" v-model="member.other_member_gender" style="height: 44px;">
                                                    <option selected disabled>Select a gender</option>
                                                    <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Age (বয়স)</label>
                                                <select class="form-control digits" v-model="member.other_member_age" style="height: 44px;">
                                                    <option selected disabled>Select a age</option>
                                                    <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label>Health Condition (শারীরিক অবস্থা)</label>
                                                <select class="form-control digits" v-model="member.other_member_health_condition" style="height: 44px;">
                                                    <option selected disabled>Select a condition</option>
                                                    <option v-for="(type, index) in healthCondition" :key="index" :value="type">{{ type }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label>Image (মেম্বার- {{ index + 3 }} এর ছবি)</label>
                                                <div class="flex items-center">
                                                    <img v-if="member.member_image_1" style="height: 80px; width: 80px; border-radius: 6px;" :src="member.member_image_1">
                                                    <input :class="member.member_image_1 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage1($event, member)">
                                                </div>
                                                <div class="flex items-center my-3">
                                                    <img v-if="member.member_image_2" style="height: 80px; width: 80px; border-radius: 6px;" :src="member.member_image_2">
                                                    <input :class="member.member_image_2 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage2($event, member)">
                                                </div>
                                                <div class="flex items-center">
                                                    <img v-if="member.member_image_3" style="height: 80px; width: 80px; border-radius: 6px;" :src="member.member_image_3">
                                                    <input :class="member.member_image_3 ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage3($event, member)">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row mt-4">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                            <router-link to="/house/list">
                                                <button class="btn btn-danger" href="#">Go Back</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Multiselect from 'vue-multiselect';
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import 'sweetalert2/src/sweetalert2.scss'
    
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker,
            Multiselect
        },
    
        data() {
            return {
                isDisabled: false,
                shelter_name: null,
                union_name: null,
                upozila_name: null,
                house: {
                    home_address: {
                        address_upozila: null,
                        address_union: null,
                        address_shelter: null
                    },
                    home: {
                        road_condition: null,
                        doc_id: null,
                        house_name: null,
                        house_type: null,
                        house_geo_location: null,
                        home_distance_from_shelter: null,
                        address_line: null,
                        images: []
                    },
                    user1: {
                        name: null,
                        nid: null,
                        phone: null,
                        gender: null,
                        age: null,
                        health_condition: null,
                        total_member: null,
                        primary: true,
                        images: []
                    },
                    user2: {
                        name: null,
                        nid: null,
                        phone: null,
                        gender: null,
                        age: null,
                        health_condition: null,
                        total_member: null,
                        primary: false,
                        images: []
                    },
                    other_members: []
                },
                house_types: ["Multi-Stored", "Concrete", "Tin-Shade", "Mud-House"],
                road_conditions: ["Asphalt", "Brick", "Country-Road"],
                genders: [
                    {
                        name: "Male", 
                        value: "male"
                    },
                    {
                        name: "Female", 
                        value: "female"
                    }
                ],
                totalMember: [ "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"],
                healthCondition: ["Good", "Sick", "Disability", "Pregnant"],
                age: [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10",
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "20",
                    "21",
                    "22",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "50",
                    "51",
                    "52",
                    "53",
                    "54",
                    "55",
                    "56",
                    "57",
                    "58",
                    "59",
                    "60",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "70",
                    "71",
                    "72",
                    "73",
                    "74",
                    "75",
                    "76",
                    "77",
                    "78",
                    "79",
                    "80",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "90"
                ],
                home_image_1: null,
                home_image_2: null,
                home_image_3: null,
                user1_image_1: null,
                user1_image_2: null,
                user1_image_3: null,
                user2_image_1: null,
                user2_image_2: null,
                user2_image_3: null
            }
        },
    
        computed: {
            ...mapState({
                shelter_list: state => state.shelter.shelter,
                upozilas: state => state.upazila.upazila,
                union: state => state.union.union
            }),

            filteredMembers() {
                return this.house.other_members.map(member => ({
                    other_member_gender: member.other_member_gender,
                    other_member_age: member.other_member_age,
                    other_member_health_condition: member.other_member_health_condition,
                    image: member.image
                }))
            }
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
            this.$store.dispatch("union/fetchUnion")
            this.$store.dispatch("upazila/fetchUpazila")
        },
    
        methods: {
            getAddress() {
                this.$store.dispatch("shelter/fetchShelterDetails", this.house.home_address.address_shelter).then(response => {
                    this.house.home_address.address_union = response.data.union.union_id
                    this.house.home_address.address_upozila = response.data.upozila.upozila_id
                    this.shelter_name = response.data.name
                    this.union_name = response.data.union.union_name
                    this.upozila_name = response.data.upozila.upozila_name
                })
            },

            getOtherUser() {
                this.house.user2.total_member = this.house.user1.total_member

                const numberOfUser = this.house.user1.total_member - 2;
                this.house.other_members = []; // Reset array

                for (let i = 0; i < numberOfUser; i++) {
                    this.house.other_members.push({
                        other_member_gender: null,
                        other_member_age: null,
                        other_member_health_condition: null,
                        image: [],
                        member_image_1: null,
                        member_image_2: null,
                        member_image_3: null
                    });
                }
            },

            uploadHomeImage1(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.home_image_1 = e.target.result
                    // this.house.home.images.push(e.target.result)
                };
            },

            uploadHomeImage2(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.home_image_2 = e.target.result
                    // this.house.home.images.push(e.target.result)
                };
            },

            uploadHomeImage3(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.home_image_3 = e.target.result
                    // this.house.home.images.push(e.target.result)
                };
            },

            uploadUser1Image1(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user1_image_1 = e.target.result
                    // this.house.user1.images.push(e.target.result)
                };
            },

            uploadUser1Image2(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user1_image_2 = e.target.result
                    // this.house.user1.images.push(e.target.result)
                };
            },

            uploadUser1Image3(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user1_image_3 = e.target.result
                    // this.house.user1.images.push(e.target.result)
                };
            },

            uploadUser2Image1(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user2_image_1 = e.target.result
                    // this.house.user2.images.push(e.target.result)
                };
            },

            uploadUser2Image2(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user2_image_2 = e.target.result
                    // this.house.user2.images.push(e.target.result)
                };
            },

            uploadUser2Image3(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.user2_image_3 = e.target.result
                    // this.house.user2.images.push(e.target.result)
                };
            },

            uploadMemberImage1(e, member) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    const imageData = e.target.result
                    member.member_image_1 = imageData
                    const index = member.image.indexOf(member.member_image_1);
                    if (index === -1) {
                        member.image.push(imageData);
                    } else {
                        member.image[index] = imageData;
                    }
                };
            },

            uploadMemberImage2(e, member) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    const imageData = e.target.result
                    member.member_image_2 = imageData
                    const index = member.image.indexOf(member.member_image_2);
                    if (index === -1) {
                        member.image.push(imageData);
                    } else {
                        member.image[index] = imageData;
                    }
                };
            },

            uploadMemberImage3(e, member) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    const imageData = e.target.result
                    member.member_image_3 = imageData
                    const index = member.image.indexOf(member.member_image_3);
                    if (index === -1) {
                        member.image.push(imageData);
                    } else {
                        member.image[index] = imageData;
                    }
                };
            },
    
            onSubmit() {
                this.isDisabled = true;
                this.house.home.doc_id = `${this.house.user1.nid}DOC${this.house.user1.phone}`;
                this.house.home.address_line = `${this.shelter_name}, ${this.union_name}, ${this.upozila_name}.`;
                this.house.home.images.push(this.home_image_1)
                this.house.home.images.push(this.home_image_2)
                this.house.home.images.push(this.home_image_3)
                this.house.user1.images.push(this.user1_image_1)
                this.house.user1.images.push(this.user1_image_2)
                this.house.user1.images.push(this.user1_image_3)
                this.house.user2.images.push(this.user2_image_1)
                this.house.user2.images.push(this.user2_image_2)
                this.house.user2.images.push(this.user2_image_3)
                this.house.other_members = this.filteredMembers;
    
                this.$store.dispatch("house/addHouse", this.house).then(response => {
                    if (response.code == 200) {
                        this.isDisabled = false,
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                    setTimeout(() => {
                        this.$router.go(); 
                    }, 2500);
                })
            }
        }
    };
</script>
    